import React, { useState } from "react";
import { ICooperativeDetails } from "../../exports/interfaces";
import { getStatusClass } from "../user/UserTable";
import useMobile from "../../hooks/useMobile";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import { renderTableExistingFilePreview } from "../../exports/functions";

const CommitteesInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  const [committeeactiveTab, setCommitteeActiveTab] = useState("Committees");
  const isMobile = useMobile();
  const { canEdit } = usePermission();
  const navigate = useNavigate();
  
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="primary-color">{committeeactiveTab}</h6>
        {canEdit("cooperatives") && (
          <button
            className="btn px-3 btn-badge fs-small"
            onClick={() =>
              navigate(`/register/edit/${cooperative?.id}`, {
                state: {
                  step: 3,
                  tab:
                    committeeactiveTab === "Executive"
                      ? "executive"
                      : "committees",
                },
              })
            }
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <Pencil size={15} />
            </i>
            {!isMobile && "Edit"}
          </button>
        )}
      </div>
      <div className="row g-3">
        <div className="col-md-12 details-text">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <button
              className="btn btn-badge-border px-3"
              onClick={() => setCommitteeActiveTab("Committees")}
              style={
                committeeactiveTab === "Committees"
                  ? { fontWeight: "bold" }
                  : {}
              }
            >
              Committees
            </button>

            <button
              className="btn btn-badge-border px-3"
              onClick={() => setCommitteeActiveTab("Executive")}
              style={
                committeeactiveTab === "Executive" ? { fontWeight: "bold" } : {}
              }
            >
              Executive
            </button>

            {/* <button className="btn btn-badge-border px-3">Tax</button> */}
          </div>
        </div>
      </div>
      <div className="dashboard-card mt-3">
        <div className="table-responsive admin-table table-checkbox">
          {committeeactiveTab === "Committees" && (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>S. no.</th>
                  <th>Photo</th>
                  <th>Committee</th>
                  <th>Name</th>
                  <th>Education</th>
                  <th>PAN</th>
                  <th>Tenure Date Start</th>
                  <th>Tenure Date End</th>
                  <th>Status</th>
                  <th className="sticky-action">Action</th>
                </tr>
              </thead>

              <tbody>
                {cooperative?.cooperativeandexecutive?.committeemember?.map(
                  (member, index) => (
                    <tr key={member.id ?? index}>
                      <td>{index + 1}</td>
                      <td>
                        {member.photoUrl
                          ? renderTableExistingFilePreview(member.photoUrl)
                          : null}
                      </td>
                      <td>{member.committeeType}</td>
                      <td>{member.fullName}</td>
                      <td>{member.education}</td>
                      <td>{member.pan}</td>
                      <td>{member.tenureStart}</td>
                      <td>{member.tenureEnd}</td>
                      <td>
                        <span
                          className={`badge rounded-pill px-3 py-2 ${getStatusClass(
                            "Active",
                          )}`}
                        >
                          Active
                        </span>
                      </td>

                      <td className="sticky-action">
                        <div className="d-flex gap-3 align-items-center">
                          <i
                            className="cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                          >
                            <Pencil size={20} />
                          </i>

                          <i
                            className="fa-solid fa-trash text-danger cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                            onClick={() => {
                              // setDeleteId(row.id);
                              //   setShowDelete(true);
                            }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          )}
          {committeeactiveTab === "Executive" && (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>S. no.</th>
                  <th>Photo</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>PAN</th>
                  <th>NID</th>
                  <th>Education</th>
                  <th className="sticky-action">Action</th>
                </tr>
              </thead>

              <tbody>
                {cooperative?.cooperativeandexecutive?.executivemember?.map(
                  (member, index) => (
                    <tr key={member.id ?? index}>
                      <td>{index + 1}</td>
                      <td>
                        {member.photoUrl
                          ? renderTableExistingFilePreview(member.photoUrl)
                          : null}
                      </td>
                      <td>{member.fullName}</td>
                      <td>{member.gender}</td>
                      <td>{member.email}</td>
                      <td>{member.mobile}</td>
                      <td>{member.pan}</td>
                      <td>{member.nid}</td>
                      <td>{member.education}</td>

                      <td className="sticky-action">
                        <div className="d-flex gap-3 align-items-center">
                          <i
                            className="cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                          >
                            <Pencil size={20} />
                          </i>

                          <i
                            className="fa-solid fa-trash text-danger cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                            onClick={() => {
                              // setDeleteId(row.id);
                              //   setShowDelete(true);
                            }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <hr />
    </>
  );
};

export default CommitteesInfo;
